import { createFileRoute } from "@tanstack/react-router";
import { CreateWorkspaceScreen } from "@/features/onboarding/CreateWorkspaceScreen";
import { meQuery } from "@/lib/api/queries";

/** The front door for a signed-in user: join what is waiting, or create a workspace. */
export const Route = createFileRoute("/workspaces/new")({
  loader: ({ context }) => context.queryClient.ensureQueryData(meQuery()),
  component: CreateWorkspaceScreen,
});
